import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
// import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Button } from 'primereact/button';
import { InputTextarea } from "primereact/inputtextarea";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";

// ------------------ COMPONENTES DE BASE--------------------------
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import Card from "../../../../../../Base/Components/Card/Card";
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------- CONSULTAS A LA API---------------------------
import {
  guardarSalidaM,
  guardarSalidaMP,
  obtenerPacasDisponiblesSalida,
} from "../../../../../../API/Suministros/SalidasMateriales/SalidasMaterialesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { CorreoCantidadMinima } from "./CorreoCantidadMinima"; 
import ReporteSalidaMP from "../Reporte/ReporteSalidaMP";
        
const AgregarSalidas = ({
  selected,
  setSelected,
  showDialog,
  setShowDialog,
  getInfo,
  actualizarScreen,
  personal,
  MateriaPrima,
}) => {

  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);
  const [quantities, setQuantities] = useState({});
  const [personals, setPersonals] = useState({});

  const [loading, setLoading] = useState(false);
  const [listaProductos, setListaProductos ] = useState([])

  // ---------------- PACAS MATERIA PRIMA ----------------
  const [showPacas, setShowPacas] = useState(false);
  const [pacasDisponibles, setPacasDisponibles] = useState([]);
  const [pacasSeleccionadas, setPacasSeleccionadas] = useState([]);
  const [requisaPacaActual, setRequisaPacaActual] = useState(null);
  const [indexRequisaPaca, setIndexRequisaPaca] = useState(null);
  const [pacasPorRequisa, setPacasPorRequisa] = useState({});

  const [salidaGuardada, setSalidaGuardada] = useState(null);
  const [showReporteSalidaMP, setShowReporteSalidaMP] = useState(false);

  const updateQuantity = (index, value) => {
    setQuantities(prevQuantities => ({
      ...prevQuantities,
      [index]: value
    }));
  };

  const updatePersonal = (index, value) => {
    setPersonals(prevPersonals => ({
      ...prevPersonals,
      [index]: value,
    }));
  };

  const abrirPacas = async (requisaDet, index) => {
    try {
      setLoading(true);
      const response = await obtenerPacasDisponiblesSalida(requisaDet?.IdProducto);
      setPacasDisponibles(response || []);
      setPacasSeleccionadas(
        pacasPorRequisa[index] || []
      );

      setRequisaPacaActual(requisaDet);
      setIndexRequisaPaca(index);
      setShowPacas(true);

    } catch (error) {
      toastShow(
        toast,
        "error",
        "Error",
        "No se pudieron obtener las pacas disponibles."
      );
    } finally {
      setLoading(false);
    }
  };
  
  //PARA ENCABEZADO  VALUES
  const initialValues = {
    // Requisa: idIngreso ? idIngreso : "",
    IdSalidaDetalle: -1,
  };

  const { values, setValues, handleInputChange, handleChange, resetForm, error, setError} = useForm(initialValues);

  const getPersonal = () =>{
    setValues({
      ...values,
      Personal: personal.find((t) => selected?.IdPersonal === t.IdPersonal),
    })
  } 

  const verificarInfo = () => {
    let error = {};
    
    selected.forEach((requisaDet, index) => {

      // MATERIAL NORMAL
      if (!MateriaPrima && !quantities[index]) {
        error[`QtySalida_${index}`] = true;

        toastShow(
          toast,
          "warn",
          "Advertencia",
          `Ingrese la cantidad a despachar de la Requisa ${requisaDet.Requisa}.`
        );

        error.error = true;
      }

      // MATERIA PRIMA
      if (
        MateriaPrima &&
        (!pacasPorRequisa[index] ||
          pacasPorRequisa[index].length === 0)
      ) {
        toastShow(
          toast,
          "warn",
          "Advertencia",
          `Seleccione al menos una paca para la Requisa ${requisaDet.Requisa}.`
        );

        error.error = true;
      }

      // PERSONAL
      if (
        !personals[index] ||
        !personals[index].IdPersonal
      ) {
        error[`Personal_${index}`] = true;

        toastShow(
          toast,
          "warn",
          "Advertencia",
          `Seleccione el personal para la salida de la Requisa ${requisaDet.Requisa}.`
        );

        error.error = true;
      }
    });

    setError(error);
    return error;
  };
  
  const agregarSalidas = async () => {
    const e = verificarInfo();

    if (e.error) {
      return;
    }

    let hasError = false;

    
    // VALIDACIONES MATERIAL NORMAL
    selected.forEach((requisaDet, index) => {
      if (!MateriaPrima) {
        if (
          quantities[index] > requisaDet.Qty ||
          quantities[index] > requisaDet.Quantity ||
          quantities[index] > requisaDet.BalanceSalida
        ) {
          toastShow(
            toast,
            "warn",
            "Advertencia",
            `La cantidad a despachar para la requisa ${requisaDet.Requisa} es mayor que la cantidad disponible.`
          );

          hasError = true;
        }
      }
    });

    if (hasError) {
      return;
    }

    setLoading(true);

    try {
      // MATERIA PRIMA
      if (MateriaPrima) {

        for (let index = 0; index < selected.length; index++) {
          const requisaDet = selected[index];
          const pacas = pacasPorRequisa[index] || [];
          const detalleMP = {
            IdRequisaDet: requisaDet?.IdRequisaDet,
            IdProduct: requisaDet?.IdProducto,

            IdUsuarioDespacho: userAuth.IdUser,

            Comentario: values?.Comentario,

            IdPersonalRecibe:
              personals[index]?.IdPersonal || null,

            Pacas: pacas.map((paca) => ({
              IdPaca: paca.IdPaca,
            })),
          };

          const resultado = await guardarSalidaMP(detalleMP);
          if (resultado?.[0]?.ESTADO !== 1) {
            toastShow(
              toast,
              "error",
              "Error",
              resultado?.[0]?.MENSAJE ||
                "No se pudo guardar la salida de Materia Prima."
            );
            setLoading(false);
            return;
          }

          // GUARDAR INFORMACION DE LA SALIDA PARA PODER IMPRIMIR
          const pesoNetoDespachado = pacas.reduce((total, paca) => total + Number(paca?.Net || 0),);
          const salidaParaReporte = {
            ...requisaDet,

            IdSalidaDetalle:
              resultado?.[0]?.IdSalidaDetalle,

            IdRequisaDetalle:
              requisaDet?.IdRequisaDet,

            IdProducto:
              requisaDet?.IdProducto,

            QtySalidaPacas:
              pacas.length,

            QtySalida:
              pesoNetoDespachado,

            UserNameDespacho:
              userAuth?.UserName,

            Comentario:
              values?.Comentario,

            NombreRecibe:
              personals[index]?.NombreConcatenado || "",
          };
          setSalidaGuardada(salidaParaReporte);
        }
        toastShow(
          toast,
          "success",
          "Salida Agregada",
          "Despacho de pacas realizado correctamente."
        );
      }

      // MATERIAL NORMAL
      else {

        const detalles = selected.map(
          (requisaDet, index) => ({
            IdRequisaDet: requisaDet?.IdRequisaDet,
            IdProduct: requisaDet?.IdProducto,
            CantidadADespachar: quantities[index],
            IdUsuarioDespacho: userAuth.IdUser,
            Comentario: values?.Comentario,
            IdPersonalRecibe:
              personals[index]?.IdPersonal || null,
          })
        );

        const resultado =
          await guardarSalidaM(detalles);

        if (resultado?.[0]?.ESTADO !== 1) {
          toastShow(
            toast,
            "error",
            "Error",
            resultado?.[0]?.MENSAJE
          );

          setLoading(false);
          return;
        }

        toastShow(
          toast,
          "success",
          "Salida Agregada",
          resultado?.[0]?.MENSAJE
        );
      }

      
      // TODO SALIÓ BIEN
      if (!MateriaPrima) {
        setTimeout(() => {
          setShowDialog(false);
          onHide();
        }, 1100);
      }
      actualizarScreen();

    } catch (error) {
      toastShow(
        toast,
        "error",
        "Error",
        "Hubo un problema al guardar la salida."
      );

    } finally {
      setLoading(false);
    }
  };

  const onHide = () => {
    setShowDialog(false);
    setSelected([]);
    setSalidaGuardada(null);
    setShowReporteSalidaMP(false);
    setPacasPorRequisa({});
    getInfo();
    resetForm();
  };

  const DialogFooter = (
    <React.Fragment>

      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />


      {MateriaPrima && (
        <Button
          label="Imprimir"
          icon="pi pi-print"
          className="p-button-text"
          disabled={!salidaGuardada}
          onClick={() => {
            setShowReporteSalidaMP(true);
          }}
        />
      )}


      <Button
        label="Guardar"
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregarSalidas();
        }}
        loading={loading}
        disabled={
          MateriaPrima &&
          salidaGuardada !== null
        }
      />

    </React.Fragment>
  );

  const eliminarCard = (index) => {
    const newSelected = [...selected];
    newSelected.splice(index, 1);
    setSelected(newSelected);
  };  
  
  useEffect(() => {
    if (showDialog) {
      getPersonal();
    }
  }, [showDialog]);

  const columnsPacas = [
    {
      field: "IdPaca",
      header: "ID",
      headerEn: "ID",
      className: "small",
      width: 130,
      minWidth: 130,
    },
    {
      field: "GinBale",
      header: "Gin Bale",
      headerEn: "Gin Bale",
      className: "medium",
      width: 220,
      minWidth: 220,
    },
    {
      field: "IdDetalleIngresoBodega",
      header: "Id Ingreso",
      headerEn: "Entry ID",
      className: "medium",
      width: 190,
      minWidth: 190,
    },
    {
      field: "Net",
      header: "Peso Neto Lbs",
      headerEn: "Net Weight Lbs",
      className: "medium",
      Format: "Currency",
      width: 220,
      minWidth: 220,
    },
  ];  

  const tablePacas = {
    Columns: columnsPacas,
    Data: pacasDisponibles,
    selected: pacasSeleccionadas,
    setSelected: (e) => setPacasSeleccionadas(e),
  };  

  const cantidadPacasSeleccionadas = pacasSeleccionadas?.length || 0;
  const pesoPacasSeleccionadas = pacasSeleccionadas?.reduce((total, paca) => total + Number(paca?.Net || 0),0 ) || 0;

  const confirmarPacas = () => {
    if (pacasSeleccionadas.length === 0) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Seleccione al menos una paca."
      );  
      return;
    }  

    const cantidadPermitida = Number(
      requisaPacaActual?.BalanceSalida ??
      requisaPacaActual?.Qty ??
      0
    );  

    if (
      cantidadPermitida > 0 &&
      pacasSeleccionadas.length > cantidadPermitida
    ) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        `Solo puede despachar ${cantidadPermitida} pacas para esta requisa.`
      );  
      return;
    }  

    setPacasPorRequisa((prev) => ({
      ...prev,
      [indexRequisaPaca]: pacasSeleccionadas,
    }));  

    setShowPacas(false);
  };  

  return (
    <div>
      <Toast ref={toast} style={{ zIndex: 50000 }} />
      <Dialog
        visible={showDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        {selected.map((requisaDet, index) => (
          <Card
            key={index}
            titulo={
              <div className="d-flex justify-content-between align-items-center">
                <h4>Salida de {requisaDet.Requisa}</h4>
              </div>
            }
            className="mb-5"
            contenido={
              <div id={`Dialog_${index}`} className="mb-4">
                {selected.length > 1 && (
                  <div className="d-flex justify-content-end">
                    <Button
                      icon="pi pi-times"
                      text
                      severity="danger"
                      aria-label="Cancel"
                      onClick={() => eliminarCard(index)}
                    />
                  </div>
                )}
                <Loader loading={loading} querySelector={`#Dialog_${index}`} />
                <div style={{ width: "auto", height: "auto" }}>
                  <div className="d-flex align-items-center">
                    <h2 className="me-3">{""}</h2>
                  </div>
                  <Toast ref={toast} style={{ zIndex: 50000 }} />
  
                  <div className="modal__input-contenedor d-flex justify-content-between">
                    <div>
                      <p className="fw-bold">Posición del Producto:
                        <p className="fw-normal">
                          {/* {(() => {
                            const items = requisaDet?.PosicionProducto?.split(', ') || [];
                            const firstItem = items[0];
                            const inventario = parseFloat(firstItem.match(/Inv:\s*([\d.,]+)/)?.[1] || '0');
                            if (requisaDet?.BalanceSalida <= inventario) {
                              return <span>{firstItem}</span>;
                            }
                            return items.map((item, index) => (
                              <span key={index}>
                                {item}
                                {index < items.length - 1 && <br />} 
                              </span>
                            ));
                          })()} */}
                        </p>
                      </p>
                    </div>
                  </div>

  
                  <div className="modal__input-contenedor">
                    <div className="field col-6 me-2">
                      <span className="p-float-label">
                        <InputText
                          name="Producto"
                          value={requisaDet?.NombreProducto}
                          onChange={handleInputChange}
                          disabled
                          style={{ width: "100%" }}
                        />
                        <label htmlFor="Producto">Producto</label>
                      </span>
                    </div>
  
                    <div className="field col-6 me-2">
                      <span className="p-float-label">
                        <InputText
                          name="UserNameRequiso"
                          disabled
                          value={requisaDet?.UserNameRequiso}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          useGrouping={false}
                        />
                        <label htmlFor="UserNameRequiso">Usuario Requisó</label>
                      </span>
                    </div>
                  </div>
  
                  <div className="modal__input-contenedor">
                    <div className="field col-6 me-2">
                      <span className="p-float-label">
                        <InputText
                          name="Area"
                          disabled
                          value={requisaDet?.Area}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          useGrouping={false}
                        />
                        <label htmlFor="Area">Area</label>
                      </span>
                    </div>
  
                    <div className="field col-6 me-2">
                      <span className="p-float-label">
                        <InputText
                          name="Area"
                          disabled
                          value={userAuth?.UserName}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                          useGrouping={false}
                        />
                        <label htmlFor="Area">Usuario Despachó</label>
                      </span>
                    </div>
                  </div>
  
                  <div className="modal__input-contenedor">
                    <div className="field col-6 me-2">
                      <span className="p-float-label">
                        <InputText
                          name="Quantity"
                          value={requisaDet?.Quantity}
                          onChange={handleInputChange}
                          disabled
                          style={{ width: "100%" }}
                        />
                        <label htmlFor="Quantity">Inventario</label>
                      </span>
                    </div>
  
                    <div className="field col-6 me-2">
                      <span className="p-float-label">
                        <InputText
                          name="Qty"
                          value={requisaDet?.Qty}
                          onChange={handleInputChange}
                          disabled
                          style={{ width: "100%" }}
                        />
                        <label htmlFor="Qty">Cantidad Solicitada</label>
                      </span>
                    </div>
                  </div>

                  <div className="modal__input-contenedor">
                    <div className="field col-6 me-2">
                        <span className="p-float-label">
                          <InputText
                            name="Area"
                            disabled
                            value={requisaDet?.UserNameAutorizoSolicita}
                            onChange={handleInputChange}
                            style={{ width: "100%" }}
                            useGrouping={false}
                          />
                          <label htmlFor="Area">Usuario Autorizó</label>
                        </span>
                    </div>

                    <div className="field col-6 me-2">
                      <span className="p-float-label">
                        <Dropdown
                          id={`Personal_${index}`}
                          value={personals[index] || null}
                          options={personal} // Lista de opciones
                          optionLabel="NombreConcatenado" // Campo a mostrar en el dropdown
                          placeholder="Seleccione un personal"
                          onChange={(e) => updatePersonal(index, e.value)} // `e.value` contiene el objeto seleccionado
                          className={error[`Personal_${index}`] ? "p-invalid" : ""}
                          style={{ width: "100%" }}
                          filter // Habilita el buscador
                          filterBy="NombreConcatenado" // Campo por el cual filtrar
                          showClear
                        />
                        <label htmlFor={`Personal_${index}`}>Código Personal</label>
                      </span>
                    </div>
                  </div>

                  <div className="modal__input-contenedor">
                    <div className="field col-6 me-2">
                      <span className="p-float-label">
                        <InputText
                          name="Balance"
                          value={requisaDet?.BalanceSalida}
                          onChange={handleInputChange}
                          disabled
                          style={{ width: "100%" }}
                        />
                        <label htmlFor="Balance">Balance</label>
                      </span>
                    </div>
  
                    <div className="field col-6 me-2">
                      {MateriaPrima ? (
                        <Button
                          type="button"
                          icon="pi pi-box"
                          label={
                            pacasPorRequisa[index]?.length > 0
                              ? `${pacasPorRequisa[index].length} Pacas seleccionadas`
                              : "Seleccionar Pacas"
                          }
                          onClick={() => abrirPacas(requisaDet, index)}
                          style={{ width: "100%" }}
                        />
                      ) : (
                        <span className="p-float-label">
                          <InputNumber
                            name={`QtySalida_${index}`}
                            value={quantities[index] || ""}
                            onChange={(e) => updateQuantity(index, e.value)}
                            style={{ width: "100%" }}
                            useGrouping={false}
                            className={
                              error[`QtySalida_${index}`] ? "p-invalid" : ""
                            }
                            autoFocus={index === 0}
                          />

                          <label htmlFor="QtySalida">
                            Cantidad a Despachar
                          </label>
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="modal__input-contenedor">                    
                    <div className="field col-6 me-2">
                      <span className="p-float-label">
                        <InputTextarea
                          name="Comentario"
                          value={requisaDet?.Comentario}
                          onChange={handleInputChange}
                          style={{ width: "100%" }}
                        />
                        <label htmlFor="Comentario">Comentario</label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            }
          ></Card>
        ))}
      </Dialog>

      {showPacas && (
        <Dialog
          visible={showPacas}
          modal
          header={`Seleccionar Pacas - ${
            requisaPacaActual?.NombreProducto || ""
          }`}
          style={{
            width: "55vw",
            maxWidth: "900px",
          }}
          onHide={() => {
            setShowPacas(false);
            setPacasSeleccionadas([]);
            setRequisaPacaActual(null);
            setIndexRequisaPaca(null);
          }}
          footer={
            <React.Fragment>
              <Button
                label="Cancelar"
                icon="pi pi-times"
                className="p-button-text"
                onClick={() => {
                  setShowPacas(false);
                  setPacasSeleccionadas([]);
                }}
              />

              <Button
                label="Aceptar"
                icon="pi pi-check"
                onClick={confirmarPacas}
              />
            </React.Fragment>
          }
        >
          <div>
            <div
              className="d-flex justify-content-between align-items-center mb-3"
            >
              <div>
                <strong>
                  Pacas seleccionadas:
                </strong>{" "}
                {cantidadPacasSeleccionadas}
              </div>

              <div>
                <strong>
                  Peso Neto Lbs:
                </strong>{" "}
                {pesoPacasSeleccionadas.toLocaleString(
                  "en-US",
                  {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  }
                )}
              </div>
            </div>

            <div style={{ height: "52vh" }}>
              <AgGrid table={tablePacas} />
            </div>
          </div>
        </Dialog>
      )}

      {showReporteSalidaMP && salidaGuardada && (
        <ReporteSalidaMP
          showReporte={showReporteSalidaMP}
          setShowReporte={setShowReporteSalidaMP}
          salida={salidaGuardada}
        />
      )}
      <div style={{ display: 'none' }}>
        <div id='CorreoCantidadMinima'>
          <CorreoCantidadMinima listaProductos={listaProductos} />
        </div>
      </div>

    </div>
  );
  
};

export default AgregarSalidas;
